
import axiosInstance from '../../../../../config/axiosInstance';
import { DiariesLabelValidation } from "../../../views/DiariesLabel/Validation/DiariesLabelValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async ( formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  const formErrors = DiariesLabelValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreateDiariesLabel`, formData);
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };